module.exports = __webpack_public_path__ + "media/centennial college - toolkit testimonials - video 2.71101df8.mp4";